<aside
  class="chatbot-history d-flex flex-column border-end border-light border-opacity-10"
  :class="{ 'is-open': is_open }"
  :aria-hidden="!is_open"
>
  <div class="d-flex align-items-center justify-content-between gap-2 px-3 pt-3 pb-2">
    <span class="text-white-50 text-xs fw-semibold text-uppercase">Chats</span>
    <div class="d-flex align-items-center gap-1">
      <button
        type="button"
        class="btn btn-sm btn-primary rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1 text-xs"
        @click="$emit('new-conversation')"
        aria-label="Start new conversation"
        title="New conversation"
      >
        <i class="bi bi-plus-lg"></i>
        <span>New</span>
      </button>
      <button
        type="button"
        class="btn btn-sm d-inline-flex align-items-center justify-content-center p-0 border-0 rounded-3 chatbot-icon-btn chatbot-history-close"
        @click="$emit('close')"
        aria-label="Close chats"
        title="Close"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>

  <div class="flex-grow-1 overflow-auto px-2 pb-2" @scroll.passive="handle_scroll">
    <div class="list-group list-group-flush gap-1">
      <BolideAssistantHistoryItem
        v-for="conversation in ordered_conversations"
        :key="conversation.id"
        :conversation="conversation"
        :is_active="conversation.id === active_conversation_id"
        :can_delete="conversations.length > 1 && conversation.source !== 'backend'"
        @select="$emit('select-conversation', $event)"
        @delete="$emit('delete-conversation', $event)"
      />
    </div>

    <button
      v-if="has_more_conversations"
      type="button"
      class="btn btn-sm btn-outline-light border-opacity-25 w-100 mt-2 d-inline-flex align-items-center justify-content-center gap-2 text-xs"
      :disabled="is_loading_conversations"
      @click="$emit('load-more-conversations')"
    >
      <i class="bi bi-arrow-down-circle"></i>
      <span>{{ is_loading_conversations ? "Loading" : "Older chats" }}</span>
    </button>
  </div>
</aside>
